var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcValidation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "24px",
    viewBox: "0 0 19 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icValidation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.89565654,0 C8.73524115,0 8.57505892,0.0626659071 8.44472142,0.188531048 L8.02689529,0.591459497 C8.02106624,0.59705943 7.2838083,1.29705094 6.08838721,2.03677531 C4.97970236,2.72290033 3.23378602,3.59062314 1.21180599,3.82822026 L0.655714844,3.89355281 C0.310168902,3.93408565 0.0429653599,4.25861505 0.0282761599,4.65541024 L0.00449364571,5.29433583 C0,5.41433437 -0.0943670017,8.27563302 0.86089732,11.7097247 C1.42701442,13.7451667 2.24657852,15.5720779 3.29673973,17.1395256 C4.62133251,19.1165683 6.30965786,20.6741494 8.3150834,21.7696028 L8.59371187,21.9218676 C8.68907509,21.973867 8.79213265,22 8.89519022,22 C8.99824778,22 9.10130534,21.973867 9.19666856,21.9218676 L9.47529703,21.7696028 C11.4804894,20.6744161 13.1690479,19.1165683 14.4936407,17.1395256 C15.5438019,15.5720779 16.363366,13.7451667 16.9294831,11.7097247 C17.8833485,8.27989964 17.7902703,5.4148677 17.7858868,5.29460249 L17.7621043,4.65541024 C17.7474151,4.25861505 17.4802115,3.93435231 17.1346656,3.89355281 L16.5785744,3.82822026 C14.5568276,3.59062314 12.8109112,2.72290033 11.7022264,2.03677531 C10.5072716,1.29731761 9.77001368,0.597326093 9.7625525,0.590392844 L9.34729115,0.189064375 C9.21672048,0.0631992339 9.05607193,0 8.89565654,0 L8.89565654,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Added-New-Validation-n-Review",
    transform: "translate(-705.000000, -803.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(670.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Success-Story",
    transform: "translate(27.000000, 622.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icValidation",
    transform: "translate(8.500000, 8.972973)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26810811,15 L4.99810811,7.425 L6.99310811,7.425 L9.20370631,13.35 L11.3281081,7.425 L13.2031081,7.425 L9.91810811,15 C9.6238517,15.6666667 9.34091522,16 9.0692987,16 C8.79768217,16 8.53061864,15.6666667 8.26810811,15 Z",
    id: "Path",
    fill: "#333333",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcValidation);
export default __webpack_public_path__ + "static/media/icValidation.07d6678ac581ee539710d3c545dfe093.svg";
export { ForwardRef as ReactComponent };